import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=a2b1bcea&scoped=true&lang=pug&"
import script from "./Contacto.vue?vue&type=script&lang=ts&"
export * from "./Contacto.vue?vue&type=script&lang=ts&"
import style0 from "./Contacto.vue?vue&type=style&index=0&id=a2b1bcea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b1bcea",
  null
  
)

export default component.exports